<template>
  <v-container class="login" fluid>
    <v-card class="center-card">
      <v-card-text>
        <v-form v-model="formValid" :disabled="$store.getters.isLoading" @submit.prevent="">
          <v-text-field
            class="mb-6"
            v-model="username"
            :label="$t('account')"
            solo
            flat
            :rules="[v => $validate.required(v) || $t('message.pleaseEnterAccount')]"
          ></v-text-field>
          <v-text-field
            v-model="password"
            type="password"
            :label="$t('password')"
            solo
            flat
            :rules="[v => $validate.required(v) || $t('message.pleaseEnterPassword')]"
          ></v-text-field>
          <FormButton
            block
            color="accent"
            class="mt-3 black--text"
            text="login"
            :disabled="!formValid"
            @click="formValid && submitLogin()"
          />
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { getDefaultPages } from '@/router/src/access'

export default {
  name: 'Login',
  data: () => ({
    formValid: false,

    username: '',
    password: '',
  }),

  methods: {
    async submitLogin() {
      if (this.$store.getters.isLoading) return

      if (!this.$validate.DataValid(this.username) || !this.$validate.DataValid(this.password)) {
        this.$store.dispatch('toggleSnack', { message: 'required', timeout: 4, allowClose: true })
        return
      }

      this.$store.dispatch('setLoading', true)

      try {
        const defaultPages = getDefaultPages(this.$config);
        const data = await this.$Fetcher.Login(this.username, this.password)
        if (
          this.$validate.DataValid(defaultPages[data.user_type]) &&
          this.$validate.DataValid(defaultPages[data.user_type][0])
        ) {
          let schoolIds = data.schools || []

          if (
            data.user_type === 'developer' ||
            (data.user_type === 'manager' && (!this.$validate.DataValid(data.schools) || data.schools.length < 1))
          ) {
            try {
              const { data: schools } = await this.$Fetcher.GetSchools()
              if (this.$validate.DataValid(schools)) {
                schoolIds = schools.map(el => el.id)
              }
              if (data.user_type === 'manager') {
                await this.updateUserSchoolsServer(data.id, schoolIds)
              }
            } catch {}
          }
          await this.gfSetUserData({
            id: data.id,
            user_type: data.user_type,
            last_login: new Date().getTime(),
            username: data.username,
            selected_school: schoolIds.length ? schoolIds[0] : null,
            schools: schoolIds,
            access_token: data.access_token,
            refresh_token: data.refresh_token,
          })

          await this.genSetting()
          this.$router.replace({ name: defaultPages[data.user_type][0] })
        } else {
          this.$store.dispatch('toggleSnack', {
            type: 'error',
            message: 'message.userTypeError',
            timeout: 4,
            allowClose: true,
          })
        }
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('toggleSnack', { type: 'error', message: err, timeout: 4, allowClose: true })
        this.$store.dispatch('setLoading', false)
      }
      return
    },
    async genSetting() {
      let payload = {}

      try {
        if (this.gEnableRegularPeriod) {
          const data = await this.$Fetcher.GetSetting()
          if (!this.$validate.DataValid(data.month_period) || data.month_period < 1) {
            payload['month_period'] = 1
          }
        }
      } catch (err) {
        this.$common.error(err)
      }

      try {
        await this.$Fetcher.UpdateSetting(payload)
      } catch (err) {
        this.$common.error(err)
      }
    },

    updateUserSchoolsServer(user_id, school_ids) {
      return new Promise(async (resolve, reject) => {
        try {
          await this.$Fetcher.UpdateStaff(user_id, {
            schools: school_ids,
          })
          resolve(true)
        } catch {
          resolve(false)
        }
      })
    },
  },
}
</script>
